import { useState } from 'react';
import {
  Stack, Title, TextInput, Textarea, Button, Group, Text,
 Radio, Checkbox, ScrollArea, Box,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { OpcionesGrandes } from './OpcionesGrandes';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';


import { YEARS_OPTIONS, PRACTICE_OPTIONS, INTEREST_OPTIONS, MAX_INTERESTS } from '../../utils/cvdl';
import { useKiosk } from '../../context/KioskContext/KioskContext';
import { api } from '../../wheel-api/client';
import { BRAND } from '../../theme/kioskTheme';

export function Ficha() {
  const { phoneRaw, setAttendee, setPhoneRaw, rutas, flujo } = useKiosk();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const form = useForm({
    initialValues: {
      name: '', phone: phoneRaw, email: '', city: '',
      yearsSinceGraduation: '', practiceContext: '',
      interestAreas: [], doubtCase: '',
      consentData: false, consentImage: false, consentPartner: false,
    },
    validate: {
      name: v => (v.trim().length < 3 ? 'Poné tu nombre y apellido' : null),
      phone: v => (v.replace(/\D/g, '').length < 10 ? 'Poné el código de área y el número' : null),
      email: v => (v && !/^\S+@\S+\.\S+$/.test(v) ? 'Revisá el email' : null),
    },
  });

  function toggleArea(next) {
    if (next.length > MAX_INTERESTS) {
      notifications.show({ message: `Elegí hasta ${MAX_INTERESTS} áreas`, color: 'orange' });
      return;
    }
    form.setFieldValue('interestAreas', next);
  }

  async function enviar(v) {
    setLoading(true);
    try {
      const { attendee } = await api.createAttendee({
        name: v.name.trim(),
        phone: v.phone,
        email: v.email.trim() || undefined,
        ficha: {
          yearsSinceGraduation: v.yearsSinceGraduation || undefined,
          practiceContext: v.practiceContext || undefined,
          interestAreas: v.interestAreas,
          doubtCase: v.doubtCase.trim() || undefined,
          city: v.city.trim() || undefined,
          country: 'AR',
        },
        consent: { data: v.consentData, image: v.consentImage, partner: v.consentPartner },
        source: 'KIOSK',
      });
      // Misma forma que devuelve /checkin: la pantalla de entrega lee
      // attendee.consentImage, no attendee.consent.image.
      setAttendee({ ...attendee, consentImage: v.consentImage });
      setPhoneRaw(v.phone);
      navigate(rutas.destino);
    } catch (err) {
      // El mensaje que ve la persona es corto; el detalle va a la consola.
      console.error('[ficha]', err.code, err.status, err.data);

      const MENSAJES = {
        TOO_MANY_INTERESTS: 'Elegí hasta 2 áreas.',
        CONSENT_REQUIRED: 'Falta aceptar que te contactemos.',
        NAME_AND_PHONE_REQUIRED: 'Necesitamos tu nombre y tu WhatsApp.',
        TAG_NUMBER_TAKEN: 'Ese número de caravana ya está cargado.',
        TAG_NUMBER_REQUIRED: 'Necesitamos tu número de caravana.',
        INVALID_TAG_NUMBER: 'Revisá el número de caravana.',
        INVALID_PHONE: 'Ese número de WhatsApp no parece válido. Revisalo.',
        DUPLICATE_KEY: 'Hay un conflicto de datos. Avisale al equipo.',
        TIMEOUT: 'El servidor tardó demasiado. Probá de nuevo.',
        NETWORK: 'Sin conexión con el servidor.',
      };

      notifications.show({
        message: MENSAJES[err.code] || `No pudimos guardar tus datos (${err.code || 'error'}). Probá de nuevo.`,
        color: 'red',
        autoClose: 6000,
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={form.onSubmit(enviar)} style={{ flex: 1, display: 'flex', minHeight: 0 }}>
      <Stack style={{ flex: 1, minHeight: 0 }} gap={0}>
        <ScrollArea style={{ flex: 1 }} px="8%">
          <Stack gap="lg" py="md">
            <TextInput label="Nombre y apellido" {...form.getInputProps('name')} />

            <TextInput
              label="WhatsApp" inputMode="numeric"
              leftSection={<Text size="xl" fw={700} c="dimmed">+54 9</Text>}
              leftSectionWidth={90}
              {...form.getInputProps('phone')}
              onChange={e => form.setFieldValue('phone', e.currentTarget.value.replace(/\D/g, ''))}
            />


            <TextInput label="Email" inputMode="email" {...form.getInputProps('email')} />
            <TextInput label="Ciudad" {...form.getInputProps('city')} />

            <Box>
              <Text c={BRAND.forvetNavy} size="xl" fw={600} mb="sm">¿Hace cuánto te recibiste?</Text>
              <OpcionesGrandes
                options={YEARS_OPTIONS}
                value={form.values.yearsSinceGraduation}
                onChange={v => form.setFieldValue('yearsSinceGraduation', v)}
              />
            </Box>

            <Box>
              <Text  c={BRAND.forvetNavy} size="xl" fw={600} mb="sm">¿Dónde ejercés hoy?</Text>
              <OpcionesGrandes
                options={PRACTICE_OPTIONS}
                value={form.values.practiceContext}
                onChange={v => form.setFieldValue('practiceContext', v)}
              />
            </Box>

            <Box>
              <Group justify="space-between" mb="sm">
                <Text  c={BRAND.forvetNavy} size="xl" fw={600}>¿En qué te gustaría profundizar?</Text>
                <Text size="lg" fw={700} c="forvet.7">
                  ELEGÍ HASTA {MAX_INTERESTS} · {form.values.interestAreas.length}/{MAX_INTERESTS}
                </Text>
              </Group>
              <OpcionesGrandes
                multiple
                options={INTEREST_OPTIONS}
                value={form.values.interestAreas}
                onChange={toggleArea}
              />
            </Box>

            <Textarea
              label="¿Qué caso te hace dudar últimamente? (opcional)"
              autosize minRows={2}
              {...form.getInputProps('doubtCase')}
            />

            <Stack gap="md">
              <Checkbox size="lg"
                label="Acepto que FORVET me contacte y guarde mis datos. (requerido)"
                {...form.getInputProps('consentData', { type: 'checkbox' })} />
              <Checkbox size="lg"
                label="Autorizo el uso de mi imagen en fotos y video."
                {...form.getInputProps('consentImage', { type: 'checkbox' })} />
              <Checkbox size="lg"
                label="Quiero recibir novedades de IPG Distribuidora."
                {...form.getInputProps('consentPartner', { type: 'checkbox' })} />
            </Stack>
          </Stack>
        </ScrollArea>

        <Box px="8%" py="md" style={{ borderTop: '1px solid var(--mantine-color-gray-3)' }}>
          <Button type="submit" fullWidth h={72}
                  loading={loading} disabled={!form.values.consentData}>
            {flujo === 'RULETA' ? 'GIRAR' : 'GUARDAR Y CONTINUAR'}
          </Button>
        </Box>
      </Stack>
    </form>
  );
}